import React, { useEffect, useState } from 'react';

import { useAuth } from '../../../../hooks/auth';

import ProductsService from '../../../../services/ProductsService';

import * as S from './styles';
import * as SM from '../../styles';
import SimpleProduct from '../SimpleProduct';
import PizzaProduct from '../PizzaProduct';
import { GridProduct } from '../GridProduct';
import { useToast } from '../../../../hooks/toast';
import { IProduct } from '../../../../interfaces/IProduct';
import { IComplementItem } from '../../../../interfaces/IComplementItem';

export interface ISelectedComplement {
  complement: IComplementItem;
  quantity: number;
}

interface ProductModalProps {
  isOpen: boolean;
  onClose: () => void;
  productId: number | null;
  addItemToCart: (payload: any) => void;
  colorsAndSizesAll: {
    colors: any[] | null;
    sizes: any[] | null;
  };
}

const ProductModal: React.FC<ProductModalProps> = (props) => {
  const {
    isOpen,
    onClose,
    productId,
    addItemToCart,
    colorsAndSizesAll,
  } = props;

  const { user } = useAuth();
  const { addToast } = useToast();

  const [product, setProduct] = useState<IProduct | null>(null);

  useEffect(() => {
    if (!productId) {
      setProduct(null);
      return;
    }

    const fetchData = async (): Promise<void> => {
      try {
        const response = await ProductsService.showProduct(
          user.empresa_id,
          productId,
        );
        setProduct(response);
      } catch (error) {
        console.log(error);
        addToast({
          type: 'error',
          title: 'Erro ao buscar dados do produto.',
        });
      }
    };
    fetchData();
  }, [addToast, productId, user.empresa_id]);

  return (
    <SM.CustomModal open={isOpen} onClose={onClose} closeAfterTransition>
      {product ? (
        <>
          {product.controlGrid === 0 && (
            <SimpleProduct
              itemToCart={addItemToCart}
              onClose={onClose}
              product={product}
            />
          )}
          {product.controlGrid === 1 && (
            <GridProduct
              itemToCart={addItemToCart}
              onClose={onClose}
              product={product}
              colorsAndSizesAll={colorsAndSizesAll}
            />
          )}
          {product.controlGrid === 2 && (
            <PizzaProduct
              itemToCart={addItemToCart}
              onClose={onClose}
              product={product}
              colorsAndSizesAll={colorsAndSizesAll}
            />
          )}
        </>
      ) : (
        <S.CustomCircularProgress />
      )}
    </SM.CustomModal>
  );
};

export default ProductModal;
